var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.form)?_c('rkm-form',{ref:"RkmForm"},[(_vm.form)?_c('BoxHistorico',{attrs:{"data":_vm.historicoData}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }